<form class="contacts-step" [formGroup]="form">
  <tui-combo-box
    tabindex="1"
    formControlName="company"
    [valueContent]="companyContent"
    [tuiTextfieldSize]="selectSize"
    [identityMatcher]="companyMatcher"
    [stringify]="companyStringify"
    (searchChange)="onSearchCompany($event)"
  >
    {{ 'common.labels.company' | translate }}

    <span class="tui-required"></span>

    <ng-template tuiDataList>
      <tui-data-list [size]="optionSize">
        <tui-opt-group>
          <button *ngFor="let item of filteredCompanies$ | async" tuiOption [value]="item">
            {{ item.name }}
          </button>
        </tui-opt-group>
      </tui-data-list>
    </ng-template>

    <input tuiTextfieldLegacy [placeholder]="'components.loyaltyCommonStep.fields.searchBy' | translate" />
  </tui-combo-box>

  <tui-textarea
    tabindex="2"
    formControlName="companyInfo"
    [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
    [maxLength]="1000"
    [rows]="12"
    [expandable]="true"
  >
    {{ 'components.loyaltyContactsStep.fields.companyInfo' | translate }}
  </tui-textarea>

  <search-users-input
    *ngIf="!isAdvertiser"
    formControlName="mentor"
    mode="single"
    [label]="'components.loyaltyContactsStep.labels.mentor' | translate"
    [textfieldSize]="isDesktop ? 'l' : 'm'"
  ></search-users-input>

  <div class="contacts-step__contacts" formArrayName="contacts">
    <ng-container *ngFor="let contact of contacts.controls; let index = index">
      <ng-container [formGroupName]="index">
        <div class="contacts-step__contact">
          <input type="hidden" formControlName="id" />

          <div class="contacts-step__contact_header">
            <span>{{ 'components.loyaltyContactsStep.labels.contact' | translate }} {{ index + 1 }}</span>

            <button
              tuiIconButton
              type="button"
              size="m"
              iconStart="@tui.trash-2"
              appearance="outline-grayscale"
              tuiAppearanceMode="checked"
              [tuiHint]="isDesktop ? ('common.buttons.delete' | translate) : ''"
              (click)="removeContact(index)"
            ></button>
          </div>

          <tui-notification size="m" *ngIf="index === 0" appearance="warning">
            {{ 'components.loyaltyContactsStep.labels.publicNotification' | translate }}
          </tui-notification>

          <tui-input [tabindex]="30 + index" formControlName="contactName" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
            {{ 'components.loyaltyContactsStep.fields.contactName' | translate }}

            <input
              tuiTextfieldLegacy
              type="text"
              [placeholder]="'components.loyaltyContactsStep.fields.enterContactName' | translate"
            />
          </tui-input>

          <div>
            <app-input-phone [tabindex]="40 + index" [size]="isDesktop ? 'l' : 'm'" formControlName="contactPhone">
              {{ 'components.loyaltyContactsStep.fields.contactPhone' | translate }}
            </app-input-phone>
          </div>

          <tui-input [tabindex]="50 + index" formControlName="contactEmail" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
            {{ 'components.loyaltyContactsStep.fields.contactEmail' | translate }}

            <input
              tuiTextfieldLegacy
              type="email"
              [placeholder]="'components.loyaltyContactsStep.fields.enterContactEmail' | translate"
            />
          </tui-input>

          <tui-textarea
            formControlName="address"
            [tabindex]="60 + index"
            [rows]="12"
            [expandable]="true"
            [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
          >
            {{ 'components.loyaltyContactsStep.fields.address' | translate }}
          </tui-textarea>

          <tui-input [tabindex]="70 + index" formControlName="website" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
            {{ 'components.loyaltyContactsStep.fields.website' | translate }}
            <span class="tui-required"></span>

            <input
              tuiTextfieldLegacy
              type="text"
              [placeholder]="'components.loyaltyContactsStep.fields.enterWebsite' | translate"
            />
          </tui-input>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div tuiGroup class="add-button" [collapsed]="true">
    <button
      tuiButton
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      [size]="'m'"
      type="button"
      (click)="addContact()"
    >
      {{ 'components.loyaltyContactsStep.buttons.addContact' | translate }}
    </button>

    <button
      tuiIconButton
      class="tui-group__auto-width-item"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      iconStart="@tui.circle-plus"
      [size]="'m'"
      type="button"
      (click)="addContact()"
    ></button>
  </div>

  <app-geocoder
    [title]="'components.contactsStep.labels.geocoderTitle' | translate"
    formControlName="mapObjects"
  ></app-geocoder>
</form>
